import { TERMS, type TermsId, type TermsItem } from './termsContent';

export type SignupMemberType = 'user' | 'clinic';

/** 가입 유형에 해당하는 항목만 표시한다. 공통 약관 원문은 기존 문서를 사용한다. */
export const getSignupTerms = (type: SignupMemberType): TermsItem[] => {
    if (type === 'user') return TERMS;
    return TERMS.filter((term) => !['thirdParty', 'sensitive', 'resumePublic'].includes(term.id));
};

export const emptySignupAgreements = (): Record<TermsId, boolean> =>
    Object.fromEntries(TERMS.map((term) => [term.id, false])) as Record<TermsId, boolean>;
